import BackendApi from '../models/BackendApi'

export default class ChatStorage {

    constructor(configApp) {
        this.chatId = 0
        this.configApp = configApp
    }

    getChatID() {
        try {
            this.chatId = localStorage.getItem("chatId")
            
            if (this.chatId == "undefined" || this.chatId == null)
            {
                this.chatId = 0;  
            } 
            return this.chatId
        }
        catch (ex) {
            console.error("open->catch", ex);
        }
    }

    removeChatId()
    {
       localStorage.removeItem("chatId")
    }

    getChatActive() {
        try {
            let api = new BackendApi(this.configApp)
            api.getClientChat(BackendApi.getTokenAccess(), (result) => {
                if (result["success"] == true) {
                    localStorage.setItem("chatId", result["chat_id"])
                    this.chatId = result["chat_id"]
                    return this.chatId;
                } else {
                    this.deleteStorageChatId()
                    return 0;
                }

            });
        }
        catch (ex) {
            console.error("open->catch", ex)
        }
    }

    deleteStorageChatId()
    {
        try {
            localStorage.removeItem("chatId")
            this.chatId = 0
        }
        catch (ex) {
            console.error("open->catch", ex)
        }
    }
}